import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';
import '@progress/kendo-theme-default/dist/all.css';
import _ from 'lodash';

function BaasicHeaderTemplate(props) {
	const { rootStore, title, t, reloadFunc, disabledBtn } = props;
	return (
		<React.Fragment>
			<div className="container--fluid">
				<div className="layout__main__subheader" style={{ position: 'relative' }}>
					<div className="flex--primary flex--grow--1">
						{rootStore != null && (
							<BaasicButton
								className="btn btn--white layout__main__subheader__back"
								icon='fa fa-long-arrow-alt-left spc--right--tny'
								onClick={() => rootStore.routerStore.goBack()}
								label='BACK'
							/>
						)}
						<h3 className="layout__main__subheader__title">{t(title)}</h3>
					</div>
					{props.children}
					{reloadFunc != null && (
						<BaasicButton
							className="btn btn--med btn--primary btn--primary--negative"
							onClick={reloadFunc}
							label={'RELOAD'}
							icon='fa fa-redo spc--right--sml'
							disabledBtn={disabledBtn}
						/>
					)}
					</div>
				</div>
		</React.Fragment>
	)
}

export default defaultTemplate(BaasicHeaderTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/BaasicHeaderTemplate.jsx